import { I18n } from 'lib/i18n'
import { get, put } from 'lib/utilities'
import { toast } from 'react-toastify'
import { loadBadges } from 'redux/navigation'

export const LOAD_DEALER = 'carts/LOAD_DEALER'
export const LOAD_DEALER_DONE = 'carts/LOAD_DEALER_DONE'
export const LOAD_DEALER_FAILED = 'carts/LOAD_DEALER_FAILED'
export const LOAD_CUSTOMER = 'carts/LOAD_CUSTOMER'
export const LOAD_CUSTOMER_DONE = 'carts/LOAD_CUSTOMER_DONE'
export const LOAD_CUSTOMER_FAILED = 'carts/LOAD_CUSTOMER_FAILED'
export const SAVE = 'carts/SAVE'
export const SAVE_DONE = 'carts/SAVE_DONE'
export const SAVE_FAILED = 'carts/SAVE_FAILED'
export const LOAD_NPS = 'carts/LOAD_NPS'
export const LOAD_NPS_DONE = 'carts/LOAD_NPS_DONE'
export const LOAD_NPS_FAILED = 'carts/LOAD_NPS_FAILED'

export const loadDealerOrders = (all) => ({ type: LOAD_DEALER, all })
export const loadDealerOrdersDone = (orders) => ({ type: LOAD_DEALER_DONE, orders })
export const loadDealerOrdersFailed = (errors) => ({ type: LOAD_DEALER_FAILED, errors })
export const loadCustomerOrders = (all) => ({ type: LOAD_CUSTOMER, all })
export const loadCustomerOrdersDone = (orders) => ({ type: LOAD_CUSTOMER_DONE, orders })
export const loadCustomerOrdersFailed = (errors) => ({ type: LOAD_CUSTOMER_FAILED, errors })
export const loadNPS = () => ({ type: LOAD_NPS })
export const loadNPSDone = (nps) => ({ type: LOAD_NPS_DONE, nps })
export const loadNPSFailed = (errors) => ({ type: LOAD_NPS_FAILED, errors })

export const saveCartFulfilled = (carts) => ({ type: SAVE_DONE, carts })
export const saveCartFailed = (errors) => ({ type: SAVE_FAILED, errors })

const initialState = {
  dealerOrders: {},
  customerOrders: {},
  nps: {}
}

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DEALER:
      return { ...state, loadingDealerOrders: true }
    case LOAD_DEALER_DONE:
      return { ...state, loadingDealerOrders: false, dealerOrders: action.orders }
    case LOAD_DEALER_FAILED:
      return { ...state, loadingDealerOrders: false }
    case LOAD_CUSTOMER:
      return { ...state, loadingCustomerOrders: true }
    case LOAD_CUSTOMER_DONE:
      return { ...state, loadingCustomerOrders: false, customerOrders: action.orders }
    case LOAD_CUSTOMER_FAILED:
      return { ...state, loadingCustomerOrders: false }
    case LOAD_NPS_DONE:
      return { ...state, nps: action.nps }
    case SAVE:
      return { ...state, savingCart: true }
    case SAVE_DONE:
      return { ...state, savingCart: false }
    default:
      return state
  }
}

export const loadDealerCartsEpic = (action$, store) =>
  action$
    .ofType(LOAD_DEALER)
    .mergeMap((action) => get(`/carts/dealer_orders.json${action.all ? '' : '?limit=10'}`))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadDealerOrdersDone(result.body)]
      } else {
        toast.error(I18n.t('action.carts/LOAD_FAILED'))
        return [loadDealerOrdersFailed(result.body.errors)]
      }
    })

export const loadCustomerCartsEpic = (action$, store) =>
  action$
    .ofType(LOAD_CUSTOMER)
    .mergeMap((action) => get(`/carts/customer_orders.json${action.all ? '' : '?limit=10'}`))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadCustomerOrdersDone(result.body)]
      } else {
        toast.error(I18n.t('action.carts/LOAD_FAILED'))
        return [loadCustomerOrdersFailed(result.body.errors)]
      }
    })

export const loadCNPSEpic = (action$, store) =>
  action$
    .ofType(LOAD_CUSTOMER)
    .mergeMap(() => get(`/carts/nps`))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadNPSDone(result.body)]
      } else {
        toast.error(I18n.t('action.carts/LOAD_FAILED'))
        return [loadNPSFailed(result.body.errors)]
      }
    })

export const saveCartEpic = (action$, store) =>
  action$
    .ofType(SAVE)
    .mergeMap((action) =>
      put('/carts/' + action.cart.id, { cart: action.cart })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveCartFulfilled(result.body), loadDealerOrders(), loadBadges()]
      } else {
        toast.error(I18n.t('action.carts/SAVE_FAILED'))
        return [saveCartFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/carts.js